
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Preloader from '../Preloder/Preloader';
import axios from 'axios';

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleShowPasswordChange = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      setError('Please fill in both fields.');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/Admin/Login`,
        { username, password },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.data.user) {
        const { id, username, role, UserId } = response.data.user;

          // console.log(response.data.user)
        // Store login details in localStorage
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('username', username);
        localStorage.setItem('userRole', role);
        localStorage.setItem('UserId', UserId);

        // console.log("UserId:", UserId);


        // Redirect to Admin Dashboard
      if(role==='supperadmin'){
        navigate('/admin');
      }
      if(role==='admin'){
        navigate('/admin');
      }

        // Clear form fields
        setUsername('');
        setPassword('');
      }
    } catch (error) {
      console.error('Login failed:', error);
      setError(error.response?.data?.message || 'Invalid username or password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && <Preloader />}
      <div className="page-wrapper">
        <Header />
        
        
        <section className="login-page section-space">
          <div className="container">
            <div className="row gutter-y-40">
              <div className="col-lg-6 wow fadeInUp" data-aos="fade-up-right" data-aos-duration="1000">
                {/* <div className="login-page__image">
                  <img src="assets/images/login/login-1-1.jpg" alt="login" />
                </div> */}


<div className="login-page__image"
                  
                  style={{
                 position: 'relative',
                 width: '100%',
                 maxWidth: '600px',
                 height: '450px',
                 overflow: 'hidden',
                 paddingRight: '10px'
               }}
             >
               {/* Heading Overlay */}
               <h2
                   style={{
                   position: 'absolute',
                   top: '10px',
                   left: '20px',
                   margin: 0,
                   padding: '6px 12px',
                   backgroundColor: 'rgba(0, 0, 0, 0.6)',
                   color: '#fff',
                   fontSize: '24px',
                   fontWeight: 'bold',
                   borderRadius: '5px',
                   zIndex: 2
                 }}
               >
                 2023–2024 Winners
               </h2>
             
               {/* Desktop Images */}
               <img
                   src="assets/images/login/schlimg.jpg"
                   alt="login"
                   className="desktop-img"
                   style={{
                   position: 'absolute',
                   width: '100%',
                   height: '100%',
                   objectFit: 'cover',
                   animation: 'slideFade 9s infinite',
                   animationDelay: '0s',
                   opacity: '0',
                   animationFillMode: 'forwards'
                 }}
               />
               <img
                   src="assets/images/login/schlimg1.jpg"
                   alt="login1"
                   className="desktop-img"
                   style={{
                   position: 'absolute',
                   width: '100%',
                   height: '100%',
                   objectFit: 'cover',
                   animation: 'slideFade 9s infinite',
                   animationDelay: '3s',
                   opacity: '0',
                   animationFillMode: 'forwards'
                 }}
               />
               <img
                   src="assets/images/login/schlimg2.jpg"
                   alt="login2"
                   className="desktop-img"
                   style={{
                   position: 'absolute',
                   width: '100%',
                   height: '100%',
                   objectFit: 'cover',
                   animation: 'slideFade 9s infinite',
                   animationDelay: '6s',
                   opacity: '0',
                   animationFillMode: 'forwards'
                 }}
               />
             
               {/* Mobile Image */}
               <img
                   src="assets/images/login/schlimg.jpg"
                   alt="login-mobile"
                   className="mobile-img"
                   style={{
                   display: 'none',
                   width: '100%',
                   height: '100%',
                   objectFit: 'cover',
                   position: 'absolute'
                 }}
               />
             
               {/* Styles */}
               <style>
                 {`
                   @keyframes slideFade {
                     0% { opacity: 0; }
                     10% { opacity: 1; }
                     30% { opacity: 1; }
                     40% { opacity: 0; }
                     100% { opacity: 0; }
                   }
             
                   @media (max-width: 768px) {
                     .desktop-img {
                       display: none !important;
                     }
             
                     .mobile-img {
                       display: block !important;
                     }
                   }
                 `}
               </style>
             </div>
              </div>
             
              <div className="col-lg-6 wow fadeInUp" data-aos="fade-up-left" data-aos-duration="1000">
                <div className="login-page__form">
                  <span className="login-page__form__top-title" style={{ backgroundColor: '#ffd767' }}>Log in</span>
                  <h2 className="login-page__form__title">Welcome to our community</h2>

                  {error && <p className="error-message" style={{ color: 'red' }}>{error}</p>}

                  <form className="login-page__form__box form-one" onSubmit={handleLogin}>
                    <div className="login-page__form__input-box form-one__control">
                      <input
                        className="form-one__control__input"
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                      />
                    </div>
                    <div className="login-page__form__input-box form-one__control">
                      <input
                        className="form-one__control__input"
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>

                    <div className="login-page__form__input-box login-page__form__checkbox-forgot">
                      <div className="login-page__form__checkbox">
                        <input
                          type="checkbox"
                          id="save_login"
                          checked={showPassword}
                          onChange={handleShowPasswordChange}
                        />
                        <label htmlFor="save_login">Show Password</label>
                      </div>
                      <Link to="/forgot-password" className="login-page__form__forgot">Forgot your password?</Link>
                    </div>

                    <div className="login-page__form__input-box">
                      <button type="submit" className="cleenhearts-btn" disabled={loading}>
                        <span className="cleenhearts-btn__icon-box">
                          <span className="cleenhearts-btn__icon-box__inner"><span className="icon-duble-arrow"></span></span>
                        </span>
                        <span className="cleenhearts-btn__text">{loading ? 'Logging in...' : 'Log in'}</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Login;
